module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/Yamanoshita-ff45863587b66ec53c76b36bab10f980.jpg";